import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { corregirChequeFisico } from "./ApiServices";
import { formatMoneda } from "../pago_proveedores/utils";
import { idInstrumentoFisico } from "./chequesFisicos.constants";

const fechaInput = (value) => {
  if (!value) return "";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
};

export default function ModalCorregir({ open, onClose, cheque, onOk }) {
  const [nroCheque, setNroCheque] = useState("");
  const [fechaPago, setFechaPago] = useState("");
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setNroCheque(cheque?.nro_cheque != null ? String(cheque.nro_cheque) : "");
    setFechaPago(fechaInput(cheque?.fecha_pago));
    setObs("");
    setError("");
  }, [open, cheque]);

  const guardar = async () => {
    const id = idInstrumentoFisico(cheque);
    if (!id) return;
    const nro = nroCheque.trim();
    if (!nro && !fechaPago) {
      setError("Completá el número de cheque o la fecha de pago.");
      return;
    }
    setGuardando(true);
    setError("");
    try {
      await corregirChequeFisico(id, {
        nro_cheque: nro || undefined,
        fecha_pago: fechaPago || undefined,
        obs: obs.trim() || undefined,
      });
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al corregir el cheque");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        Corregir nro/fecha — N° {cheque?.nro_cheque || idInstrumentoFisico(cheque) || ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Typography variant="body2" color="text.secondary">
            Solo Casa Central. El importe no se corrige acá: si está mal hay
            que anular el recibo
            {cheque?.importe != null
              ? ` (importe actual ${formatMoneda(cheque.importe)})`
              : ""}
            .
          </Typography>
          <TextField
            label="N° cheque"
            size="small"
            fullWidth
            value={nroCheque}
            onChange={(e) => setNroCheque(e.target.value)}
            disabled={guardando}
          />
          <TextField
            label="Fecha de pago"
            size="small"
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            value={fechaPago}
            onChange={(e) => setFechaPago(e.target.value)}
            disabled={guardando}
          />
          <TextField
            label="Observaciones (opcional)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={
            guardando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          Guardar corrección
        </Button>
      </DialogActions>
    </Dialog>
  );
}
